import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import orderLimitsServices from '@src/services/orderLimits.services';

export const getMaximumLoadedAmount = createAsyncThunk(
  'getMaximumLoadedAmount',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await orderLimitsServices.getMaximumLoadedAmount({
        customerId,
        vouId: body?.vouId ?? 1,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getOrderLimitDate = createAsyncThunk(
  'getOrderLimitDate',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }

      const data = {
        customerId,
        vouId: body?.vouId ?? 1,
        tempOrderNo: body?.tempOrderNo,
        orderTypeId: body?.orderTypeId,
      };

      const res = await orderLimitsServices.getOrderLimitDate(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  maximumLoadedAmount: '0',
  orderLimitDate: {},
};

export const orderLimitsSlice = createSlice({
  name: 'orderLimits',
  initialState,
  reducers: {
    resetOrderLimits: (state) => {
      state.orderLimitDate = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaximumLoadedAmount.fulfilled, (state, action) => {
      state.maximumLoadedAmount = action?.payload?.data?.value?.toString() || '0';
    });
    builder.addCase(getMaximumLoadedAmount.rejected, (state) => {
      state.maximumLoadedAmount = '0';
    });
    builder.addCase(getOrderLimitDate.fulfilled, (state, action) => {
      state.orderLimitDate = action?.payload?.data;
    });
    builder.addCase(getOrderLimitDate.rejected, (state) => {
      state.orderLimitDate = {};
    });
  },
});

export const { resetOrderLimits } = orderLimitsSlice.actions;
